import { default as COLORS } from './../../../../theme/colors';

const APP_COLORS = {

  
};

export default {
  ...COLORS,
  ...APP_COLORS,
};
